module.exports = __webpack_public_path__ + "static/posy-d0c4e1e7979d75923d4d8b49c191bc6e.jpg";